<template>
    <div id="links" class="content-spacer">
        <div id="actions">
            <button v-if="landingPageLabel1 !== null" @click="openLink(landingPageLink1)" class="button-secondary">
                {{ landingPageLabel1 }}
            </button>
            <button v-if="landingPageLabel2 !== null" @click="openLink(landingPageLink2)" class="button-secondary">
                {{ landingPageLabel2 }}
            </button>
            <button v-if="landingPageLabel3 !== null" @click="openLink(landingPageLink3)" class="button-secondary">
                {{ landingPageLabel3 }}
            </button>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";
    import axios from "axios";

    export default {
        name: "Links",
        data: function () {
            return {
                landingPageLabel1: "",
                landingPageLabel2: "",
                landingPageLabel3: "",
                landingPageLink1: "",
                landingPageLink2: "",
                landingPageLink3: ""
            }
        },
        computed: {
            ...mapState({
                siteId: state => state.session.siteId,
                accountId: state => state.session.accountId,
                checkId: state => state.session.checkId,
                expirationTicks: state => state.session.expirationTicks,
                checkNumber: state => state.session.checkNumber,
                businessDate: state => state.session.businessDate,
                checkOpenDateTime: state => state.session.checkOpenDateTime,
                checkTotal: state => state.session.checkTotal,
                siteNumber: state => state.session.siteNumber
            }),
        },
        methods: {
            ...mapMutations([
                "setLoadingStatus",
            ]),
            async SetNSPayLinks() {
                this.setLoadingStatus(true);

                if (this.siteId === undefined || this.accountId === undefined || this.checkId === undefined) {
                    // Same with NSPay, we could be here if user triggers a page refresh or pressing back from the opened links. 
                    // To reload the parameters, simply go back to the previous landing page.
                    this.$router.go(-1);
                    return;
                }

                // Get NSPayLinks
                const nsPayLinksUrl = "/site/nspaylinks/" + this.siteId + "/" + this.accountId;

                await axios.get(nsPayLinksUrl)
                    .then(response => {
                        if (response.data) {
                            let links = response.data;
                            this.landingPageLabel1 = links.data.landingPageLabel1;
                            this.landingPageLabel2 = links.data.landingPageLabel2;
                            this.landingPageLabel3 = links.data.landingPageLabel3;
                            this.landingPageLink1 = links.data.landingPageLink1;
                            this.landingPageLink2 = links.data.landingPageLink2;
                            this.landingPageLink3 = links.data.landingPageLink3;
                        }
                        else {
                            this.$router.push("/error/1023");
                        }
                    })
                    .catch(error => {
                        if (error.data && error.data.errorMessage) {
                            console.error(error.data.errorMessage);
                        }
                        else {
                            console.error(error);
                        }
                        this.$router.push("/error/1023");
                    })
                    .finally(() => {
                        this.setLoadingStatus(false);
                    });
            },
            openLink: function (value) {
                let link = value.replace("<SiteGuid>", this.siteId)
                    .replace("<CheckGuid>", this.checkId)
                    .replace("<ExpirationTick>", this.expirationTicks)
                    .replace("<CheckNumber>", this.checkNumber)
                    .replace("<AccountGuid>", this.accountId)
                    .replace("<SiteNumber>", this.siteNumber)
                    .replace("<BusinessDate>", this.businessDate)
                    .replace("<CheckOpenDateTime>", this.checkOpenDateTime)
                    .replace("<CheckTotal>", this.checkTotal);

                // Check if link is an NSPaylink. If NSPaylink, redirect to index.
                if (window.location.hostname === (new URL(link)).hostname &&
                    link.indexOf("landing") !== -1 &&
                    link.indexOf("s=") !== -1 &&
                    link.indexOf("c=") !== -1 &&
                    link.indexOf("e=") !== -1 &&
                    link.indexOf("a=") !== -1) {

                    this.$router.push("/");
                    return;
                }

                window.location.href = link;
                return;
            },
        },
        async mounted() {
            await this.SetNSPayLinks();
        }
    }
</script>

<style scoped>
    #links {
        display: flex;
        align-items: stretch;
        align-content: stretch;
    }

    #actions {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

        #actions > button {
            background-color: var(--white);
            width: 100%;
            margin-bottom: 30px;
        }
</style>